module.exports = __webpack_public_path__ + "img/click.a2e6f6e6.svg";